var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var MasterLayoutModuleComponent = /** @class */ (function (_super) {
    __extends(MasterLayoutModuleComponent, _super);
    function MasterLayoutModuleComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MasterLayoutModuleComponent;
}(React.PureComponent));
export { MasterLayoutModuleComponent };
export var masterLayoutPropsMapper = function (state) { return ({
    activeModules: state.activeModules,
    modules: state.modules,
    left: state.left,
    right: state.right,
    main: state.main,
    themeManipulation: state.themeManipulation,
    renderer: state.renderer,
    buttons: state.buttons,
}); };
export var breakpoints = {
    smallMobile: { width: 320 },
    mobile: { width: 375 },
    tablet: { width: 768 },
    desktop: { width: 1280 },
    wide: { width: 1600 },
    ultraWide: { width: 1920 },
    extremlyWide: { width: 2560 }
};
